// extracted by mini-css-extract-plugin
export default {"plus":"Status_plus__6Sxl4","minus":"Status_minus__ZMbdR","question":"Status_question__4ZYu-"};